"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processAdjustments = void 0;
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("./utils");
/**
 * Processes order and its orderitems and returns all adjustments
 * @param order Order
 */
function processAdjustments(order, orderItemCount, orderGrossPrice, processedItems) {
    var _a, _b, _c, _d, _e;
    const adjustments = [];
    const adjustmentPart = {
        orderId: order.id,
        createdAt: order.createdAt,
        venueId: (_a = order.venue) === null || _a === void 0 ? void 0 : _a.id,
        storeId: (_b = order.store) === null || _b === void 0 ? void 0 : _b.id,
        deviceId: (_c = order.updatedByDevice) === null || _c === void 0 ? void 0 : _c.id,
        orderTypeId: (_d = order.orderType) === null || _d === void 0 ? void 0 : _d.id,
    };
    const subTotalAfterAdjustment = (0, utils_1.getNetSubTotal)(order.subTotal, order.adjustments);
    (_e = order.adjustments) === null || _e === void 0 ? void 0 : _e.forEach(adjustment => {
        if (order.status !== domain_1.OrderStatus.VOID) {
            adjustments.push({
                ...adjustment,
                amount: (0, utils_1.getAdjustmentValue)(adjustment.doNotIncludeInSalesAmount
                    ? subTotalAfterAdjustment
                    : order.subTotal, [adjustment]),
                name: adjustment.name
                    ? adjustment.name
                    : adjustment.adjustmentType === domain_1.AdjustmentType.DISCOUNT
                        ? 'Manual Discounts'
                        : 'Manual Surcharges',
                orderItemId: null,
                belongsTo: 'Order',
                itemsCount: orderItemCount,
                grossPrice: orderGrossPrice,
                ...adjustmentPart,
            });
        }
    });
    processedItems === null || processedItems === void 0 ? void 0 : processedItems.forEach(orderItem => {
        var _a;
        if (orderItem.status !== domain_1.OrderItemStatus.VOID &&
            orderItem.status !== domain_1.OrderItemStatus.CANCELLED) {
            (_a = orderItem.adjustments) === null || _a === void 0 ? void 0 : _a.forEach(adjustment => {
                const amount = adjustment.adjustmentType === domain_1.AdjustmentType.REWARD
                    ? (0, utils_1.getItemRewardValue)(orderItem, [
                        adjustment,
                    ])
                    : (0, utils_1.getAdjustmentValue)(orderItem.grossPrice, [adjustment]);
                adjustments.push({
                    ...adjustment,
                    name: adjustment.name
                        ? adjustment.name
                        : adjustment.adjustmentType === domain_1.AdjustmentType.DISCOUNT
                            ? 'Manual Discounts'
                            : 'Manual Surcharges',
                    amount: amount,
                    orderItemId: orderItem.id,
                    belongsTo: 'OrderItem',
                    itemsCount: orderItem.quantity,
                    grossPrice: orderItem.grossPrice,
                    ...adjustmentPart,
                });
            });
        }
    });
    return adjustments;
}
exports.processAdjustments = processAdjustments;
//# sourceMappingURL=adjustmentHelper.js.map